import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=05a05730&"
import script from "./Direct.vue?vue&type=script&lang=js&"
export * from "./Direct.vue?vue&type=script&lang=js&"
import style0 from "./Direct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports